import {Expose} from 'class-transformer';

export class UserMovieGenreApiModel {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
